import BackButton from '@sharedComponents/BackButton/BackButton';
import { ThemedView } from '../../../../theme';
import { ColorTokens } from '@voltmoney/schema';
import Typography from '@sharedComponents/typography/Typography';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import {useDarkMode} from '@app/utils';
import { View } from 'react-native';
import gs from '@app/styles/globalStyles';
import { ThemedText } from '@app/theme/Components';


type EnterEmailHeaderProps = {
  navigation : NativeStackNavigationProp<PrivateStackParamList>,
  pageName? : keyof PrivateStackParamList
}

const EnterEmailHeader = ({ navigation , pageName } :EnterEmailHeaderProps ) => {
  const isDarkMode = useDarkMode()
  return (
     <ThemedView
     flexDirection='row'
     alignItems='center'
     justifyContent='space-between'
     bg={'bg-surface-primary'}
     borderBottomWidth={1}
     borderBottomColor='border-primary'
     px="lg"
     height={60}
     >
      <ThemedView flexDirection='row' alignItems='center'>
        <ThemedView mr='md'>
        <BackButton pageName={pageName} navigation={navigation} />
        </ThemedView>
        <ThemedText color='text-primary' variant='b3m'>{'Verify email'}</ThemedText>
      </ThemedView>
      <NeedHelp />
      </ThemedView>

  );
};

export default EnterEmailHeader;
